import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ffc58fb2&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=ffc58fb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc58fb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffc58fb2')) {
      api.createRecord('ffc58fb2', component.options)
    } else {
      api.reload('ffc58fb2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ffc58fb2&scoped=true", function () {
      api.rerender('ffc58fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pendingGrants/index.vue"
export default component.exports